import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/buzas/Header";
import { Hero } from "@/components/buzas/Hero";
import { ProblemSolution } from "@/components/buzas/ProblemSolution";
import { Benefits } from "@/components/buzas/Benefits";
import { Authority } from "@/components/buzas/Authority";
import { CtaForm } from "@/components/buzas/CtaForm";
import { Faq } from "@/components/buzas/Faq";
import { Footer } from "@/components/buzas/Footer";
import { FloatingWhatsapp } from "@/components/buzas/FloatingWhatsapp";
import { CookieConsent } from "@/components/buzas/CookieConsent";
import { PrivacyPolicy } from "@/components/buzas/PrivacyPolicy";

const LandingPage = () => {
    return (
        <main data-testid="landing-page" className="bg-white">
            <Header />
            <Hero />
            <ProblemSolution />
            <Benefits />
            <Authority />
            <CtaForm />
            <Faq />
            <Footer />
            <FloatingWhatsapp />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route
                        path="/pecas-maquinas-agricolas"
                        element={<LandingPage />}
                    />
                    <Route
                        path="/politica-de-privacidade"
                        element={<PrivacyPolicy />}
                    />
                </Routes>
                <CookieConsent />
            </BrowserRouter>
        </div>
    );
}

export default App;
